import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'cream' | 'green';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    cream: 'bg-[#FEFAE0]',
    green: 'bg-[#2D6A4F] text-white'
  };
  return <section id={id} className={`py-10 md:py-20 px-4 md:px-6 lg:px-8 ${backgrounds[background]} ${className}`} data-id="element-174">
      <div className="max-w-6xl mx-auto w-full" data-id="element-175">{children}</div>
    </section>;
}